import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
/* src/app/page.members/view.scss: no such file or directory */`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];
    public communities: string[] = [];

    public search: any = {
        text: "",
        role: ""
    };

    public roles: string[] = ['admin', 'infra', 'service'];

    public showInviteModal: boolean = false;
    public inviteData: any = { email: '', name: '', password: '', role: 'infra', job_title: '' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        if (!this.service.auth.allow.role("admin", "/dashboard")) return;
        await this.loadCommunities();
        await this.load();
    }

    public async loadCommunities() {
        const { code, data } = await wiz.call("communities");
        if (code === 200) {
            this.communities = data || [];
        }
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", this.search);
        if (code === 200) {
            this.members = data || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async openInvite() {
        this.inviteData = { email: '', name: '', password: '', role: 'infra', job_title: '' };
        this.showInviteModal = true;
        await this.service.render();
    }

    public async invite() {
        const payload = {
            ...this.inviteData,
            email: (this.inviteData.email || '').trim(),
            name: (this.inviteData.name || '').trim(),
        };

        if (!payload.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }
        if (!payload.name) {
            await this.service.modal.error("이름을 입력해주세요.");
            return;
        }
        if (!payload.password) {
            await this.service.modal.error("비밀번호를 입력해주세요.");
            return;
        }

        const { code, data } = await wiz.call("invite", payload);
        if (code === 200) {
            await this.service.modal.success("초대가 완료되었습니다.");
            this.showInviteModal = false;
            await this.load();
        } else {
            const message = typeof data === 'string' ? data : (data?.message || "초대에 실패했습니다.");
            await this.service.modal.error(message);
        }
    }

    public async updateJobTitle(member: any, job_title: string) {
        await wiz.call("update_job_title", { id: member.id, job_title: job_title });
        member.job_title = job_title;
        await this.service.render();
    }

    public async removeMember(member: any) {
        let res = await this.service.modal.show({
            title: "멤버 제거",
            message: `${member.name}님을 멤버에서 제거하시겠습니까?`,
            action: "제거",
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code } = await wiz.call("remove", { id: member.id });
        if (code === 200) {
            await this.load();
        }
    }

    public roleLabel(role: string) {
        const map: any = { 'admin': '관리자', 'infra': '인프라 담당자', 'service': '서비스 담당자' };
        return map[role] || role;
    }

    public roleClass(role: string) {
        switch (role) {
            case 'admin': return 'bg-purple-100 text-purple-700';
            case 'infra': return 'bg-cyan-100 text-cyan-700';
            case 'service': return 'bg-emerald-100 text-emerald-700';
            default: return 'bg-gray-100 text-gray-600';
        }
    }
}

export default PageMembersComponent;